var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{class:[
    'asc-panel',
    _vm.noSpacing ? 'asc-panel--noSpacing' : '',
    _vm.flat ? 'asc-panel--flat' : '',
    _vm.outlined ? 'asc-panel--outlined' : '',
    _vm.dark ? 'asc-panel--dark' : '',
    _vm.hover ? 'asc-panel--hover' : '' ],attrs:{"flat":_vm.flat,"tile":_vm.tile,"outlined":_vm.outlined,"loading":_vm.loading,"loader-height":_vm.loaderHeight,"dark":_vm.dark,"hover":_vm.hover,"disabled":_vm.disabled}},[(_vm.hasFullscreenIcon)?_c('asc-full-screen-icon',{on:{"onFullScreenToggle":_vm.handleFullScreenToggle}}):_vm._e(),(_vm.hasTitleSlot)?_c('v-card-title',{staticClass:"asc-panel__title"},[_c('v-clamp',{staticClass:"clamp",attrs:{"autoresize":"","max-lines":2}},[_vm._t("title")],2)],1):_vm._e(),(_vm.hasSubTitleSlot)?_c('v-card-subtitle',{staticClass:"asc-panel__subtitle"},[_vm._t("subtitle")],2):_vm._e(),(_vm.hasTitleSlot)?_c('v-divider'):_vm._e(),_c('v-card-text',{class:['asc-panel__text', !_vm.hasTitleSlot ? 'asc-panel__text-cover' : ''],style:({
      minHeight: (_vm.contentMinHeight + "px"),
      maxHeight: _vm.contentMaxHeight
        ? (_vm.contentMaxHeight + "px")
        : _vm.contentMaxHeight,
      padding: (_vm.contentPaddingY + "px " + _vm.contentPaddingX + "px"),
      paddingBottom: _vm.contentPaddingBottom
        ? (_vm.contentPaddingBottom + "px")
        : _vm.contentPaddingBottom,
    })},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }